<template>
    <div>
      <FtRegistrasiLayananMainCard/>
    </div>
  </template>
  
  <script>
  import FtRegistrasiLayananMainCard from "@/components/public_registrasi_diklat/FtRegistrasiLayananCardMain.vue";
  import ERole from "@/models/e-role";
  
  export default {
    name: "RegistrasiLayananView",
    components: {
      FtRegistrasiLayananMainCard
    },
    data() {
      return {
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
      isAdmin(){
        console.log([ERole.ROLE_ADMIN, ERole.ROLE_USER].some(
            (x) => this.currentUser.roles.includes(x)))
        return [ERole.ROLE_ADMIN, ERole.ROLE_USER].some(
            (x) => this.currentUser.roles.includes(x));
      },
      isDiklat(){
        return [ERole.ROLE_DIKLAT].some(
            (x) => this.currentUser.roles.includes(x));
      },
      isVendorMP(){
        return [ERole.ROLE_MP].some(
            (x) => this.currentUser.roles.includes(x));
      }

    },
    methods: {
  
    },
  
  
  }
  </script>
  
  <style scoped>
  </style>